import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DATE_FORMATS } from '../../../utils';

const DateTab = (props) => {
  const handleOnClick = () => {
    props.onClick(props.day);
  };

  const {
    day,
    selectedDate,
  } = props;

  const classes = classNames('date-tab', {
    'is-selected': day.startOf('d').isSame(selectedDate.startOf('d')),
  });

  return (
    <button type="button" className={classes} onClick={handleOnClick}>
      <span className="day">{day.format(DATE_FORMATS.DAY_OF_WEEK)}</span>
      <span className="date">{day.format(DATE_FORMATS.DAY_OF_MONTH)}</span>
    </button>
  );
};

DateTab.propTypes = {
  day: PropTypes.object.isRequired,
  selectedDate: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default DateTab;



// WEBPACK FOOTER //
// ./components/calendar-header/date-tab/index.js